var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSuitcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5938 21.75V41.4375C46.5938 42.9908 45.3346 44.25 43.7812 44.25H4.21875C2.66541 44.25 1.40625 42.9908 1.40625 41.4375V21.75",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0192 29.25H10.1547C9.41484 29.25 8.70478 28.9584 8.17838 28.4386L1.40625 21.75V11.0625C1.40625 9.50916 2.66541 8.25 4.21875 8.25H43.7812C45.3346 8.25 46.5938 9.50916 46.5938 11.0625V21.75L39.8216 28.4386C39.2952 28.9585 38.5852 29.25 37.8453 29.25H34.9688",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 8.25H15V4.21875C15 2.66541 16.2592 1.40625 17.8125 1.40625H30.1875C31.7408 1.40625 33 2.66541 33 4.21875V8.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 37.5C30.2132 37.5 35.25 32.4632 35.25 26.25C35.25 20.0368 30.2132 15 24 15C17.7868 15 12.75 20.0368 12.75 26.25C12.75 32.4632 17.7868 37.5 24 37.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0379 21.8671C26.0379 21.8671 24.9137 20.8302 23.181 21.3522C21.59 21.8315 21.1948 24.0084 22.276 24.8564C22.8969 25.3434 23.831 25.7437 25.0899 26.1887C27.9075 27.1847 26.8659 31.1583 23.9998 31.1773C22.8813 31.1847 22.3584 31.1138 21.3759 30.471",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 32.2501V31.178",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21.2094V20.25",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuitcase);
export default __webpack_public_path__ + "static/media/ic-suitcase.0c830f857680c8e25a53f440000fe079.svg";
export { ForwardRef as ReactComponent };